module.exports = __webpack_public_path__ + "media/images/competitions/file-new-b0e14caa490903c05681aed82adc3815.png";